import React from 'react';

import { ProcessSectionLayout } from '@/layouts/pages/business';
import { ProcessFeature } from '@/views/business';

const ProcessSection = () => (
  <ProcessSectionLayout>
    <ProcessFeature
      index="01"
      title="이슈"
      iconUrl="/pages/business/viral/sections/process/icon_1.png"
      contents={[
        `신규 브랜드 및 신제품 런칭`,
        `프로모션 이벤트 실행`,
        `기업 홈페이지 및 쇼핑몰 홍보`,
      ]}
    />
    <ProcessFeature
      index="02"
      title="기획"
      iconUrl="/pages/business/viral/sections/process/icon_2.png"
      contents={[
        `희망 노출 매체 설정`,
        `보도 희망 언론 설정 및 협의`,
        `언론 송출 기사 기획 및 생성`,
        `콘텐츠의 고객사 컨펌`,
      ]}
    />
    <ProcessFeature
      index="03"
      title="진행"
      iconUrl="/pages/business/viral/sections/process/icon_3.png"
      contents={[`Presskit 언론사에 배포`]}
    />
    <ProcessFeature
      index="04"
      title="완료"
      iconUrl="/pages/business/viral/sections/process/icon_4.png"
      contents={[
        `기사 콘텐츠 송출`,
        `핵심 키워드 노출 확인`,
        `언론송출 효과 평가 및 피드백`,
      ]}
    />
  </ProcessSectionLayout>
);

export default ProcessSection;
